import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment.prod';
import { enableProdMode } from '@angular/core';
import posthog from 'posthog-js'

posthog.init('phc_wJqvZzHnX7pQ94hknFi5VKvuLcbhBo2dFZjmCtjp8m3Q', {
    api_host: 'https://us.i.posthog.com',
    defaults: '2026-05-30'
})

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
